import Format from 'app/src/data/Format';
import PaymentType from 'app/src/data/models/PaymentType';
import RetailCollection from 'app/src/data/models/RetailCollection';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class PaymentTypeCollection extends RetailCollection {
  get model() {
    return PaymentType;
  }

  /**
   * Return the REST url for collection of Payment Types
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/PaymentType.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    if (!response.PaymentType) {
      throw new Error(
        'The response is malformed, unable to retrieve the paymentType from the response.'
      );
    }

    // response.PaymentType is an array of the Payment Type structures we want
    // Sort them by alphabetical order to match the legacy behavior
    // (but Account and Cash should always be first)

    // Also, we check if the response is an array or not,
    // since Retail API does returns single entity as object
    // we want to make sure we always deal with an array further down below
    // in the code, so we do the following transformation
    const paymentTypes = Array.isArray(response.PaymentType)
      ? response.PaymentType
      : [response.PaymentType];

    let sortedPaymentTypes = [];

    // Add Account first and remove it from the list of payment types
    // so it doesn't get sorted like the rest will
    for (let i = 0; i < paymentTypes.length; i++) {
      if (paymentTypes[i].type === PaymentType.Types.CREDIT_ACCOUNT) {
        sortedPaymentTypes.push(paymentTypes.splice(i, 1)[0]);
        break;
      }
    }

    // Add Cash second and remove it from the list of payment types
    // so it doesn't get sorted like the rest will
    for (let i = 0; i < paymentTypes.length; i++) {
      if (paymentTypes[i].type === PaymentType.Types.CASH) {
        sortedPaymentTypes.push(paymentTypes.splice(i, 1)[0]);
        break;
      }
    }

    // Sort the rest by display name
    // Callback Documentation:
    // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/sort

    // A string is "less than" another string if it comes before it alphabetically,
    // so we can use this to our advantage.
    paymentTypes.sort((a, b) => {
      let aName = a.name.toLowerCase();
      let bName = b.name.toLowerCase();

      if (aName < bName) {
        return -1;
      }
      if (aName > bName) {
        return 1;
      }

      return 0;
    });

    // Add the sorted elements after Account and Cash
    sortedPaymentTypes = sortedPaymentTypes.concat(paymentTypes);

    // store the count if present
    this.recordCount = Format.parseInt((response['@attributes'] || {}).count, 0);

    return sortedPaymentTypes;
  }
}
